// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-visualization-component {
	position: relative;
	min-height: 64px;
	/* 44px loading indicator + 2 x 10px margins */
}

.web-visualization-component iframe {
	border: none;
	padding: 0;
	margin: 0;
	width: 100%;
	overflow: hidden;
	display: block;
}

.web-visualization-component .loading-indicator {
	position: absolute;
	left: 0;
	top: 0;
	height: 44px;
	box-sizing: border-box;
	line-height: 44px;
	right: 0;
	padding: 10px 0 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/WebVisualization.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,8CAA8C;AAC/C;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,sBAAsB;CACtB,iBAAiB;CACjB,QAAQ;CACR,4BAA4B;AAC7B","sourcesContent":[".web-visualization-component {\n\tposition: relative;\n\tmin-height: 64px;\n\t/* 44px loading indicator + 2 x 10px margins */\n}\n\n.web-visualization-component iframe {\n\tborder: none;\n\tpadding: 0;\n\tmargin: 0;\n\twidth: 100%;\n\toverflow: hidden;\n\tdisplay: block;\n}\n\n.web-visualization-component .loading-indicator {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 44px;\n\tbox-sizing: border-box;\n\tline-height: 44px;\n\tright: 0;\n\tpadding: 10px 0 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
